import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {GoBackIcon} from 'imports/IconsImports';

import {
  IconButton,
  CircularProgress
} from 'material-ui';

import {
  ProjectShow,
  Appointment,
  ValidationBar,
} from 'imports/ComponentsImports';

const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  navigatorContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  header: {
    marginLeft: '10px',
    cursor: 'pointer',
  },
  titleBar: {
    width: '100%',
    backgroundColor: '#212F55',
    color: 'white',
    padding: '8px'
  },
  informationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0px 20px 0px'
  },
  commentsContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '20px'
  }
}

class ProjectView extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: props.cookies.get('token'),
      user: props.cookies.get('user'),
      signatures: [],
      loading: true,
      error: false,
    }
  }

  componentDidMount() {
    this.getProject();
    this.getSignatures();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <h1> Hubo un error al cargar el proyecto proyecto</h1>
          <a href="/portfolio/files"> Intentalo nuevamente aquí</a>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div style={styles.pageContainer}>
        {this.state.project && this.state.project.state.length > 0 && this.state.project.state[0].state === "En proceso de firma" ?
          <ValidationBar project={this.state.project} />
          : null
        }
        <div style={styles.navigatorContainer}>
          <IconButton
            onClick={() => this.props.history.push('/portfolio/files')}
          >
            <GoBackIcon />
          </IconButton>

          <h2 onClick={() => this.props.history.push('/portfolio/files')} style={styles.header}> Portafolio de Proyectos </h2>
        </div>
        <div style={styles.titleBar}>
          {this.state.project && ("FICHA DE PROYECTO: "+ this.state.project.information.name.toUpperCase())}
        </div>
        <div style={styles.informationContainer}>
          <div style={styles.informationText}>Debes completar los siguientes campos con la información de tu proyecto. <br></br>
          Una vez completado deberás enviar el proyecto a las personas involucradas para que lo firmen.</div>
        <Appointment />
        </div>
          {this.state.project && this.state.signatures && <ProjectShow project={this.state.project} signatures={this.state.signatures}/>}
      </div>
    );
  }

  getProject = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.oneProjectFullInformation(this.props.match.params.id))
    .then((response) => {
      this.setState({
        project: response.data,
        loading: false,
        error: false,
      });
    })
    .catch((error) => {
      console.error(error);
      this.setState({
        loading:false,
        error: true,
      })
    })
  }

  getSignatures = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.signatures(this.props.match.params.id))
      .then((response) => {
        this.setState({
          signatures: response.data.signatures,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        this.setState({
          error: true,
          loading: false,
        })
      });
  }
}

export default withCookies(withRouter(ProjectView));



// WEBPACK FOOTER //
// ./src/views/files/FileView.js